/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { notBlank } from '@ng-falcon/ngf-form/+validators/not-blank';

@Pipe({
    name: 'isAnyRequired',
    standalone: false
})
export class IsAnyRequiredPipe implements PipeTransform {

  transform(controls: readonly FormControl[]): boolean {
    return controls.some(control =>
      control.hasValidator(Validators.required) ||
      control.hasValidator(Validators.requiredTrue) ||
      control.hasValidator(notBlank)
    );
  }

}
